<template>
  <generic-list
    :query-fields="queryFields"
    :columns="columns"
    :form-fields="formFields"
    :editable-fields="editableFields"
    :fetch-data="fetchData"
    :add-data="addData"
    :update-data="updateData"
    :delete-data="deleteData"
    :add-fields="addFields"
    
  >
    <template #avatar="{ row }">
      <el-avatar :src="mediaUrl + row.avatar || 'https://example.com/default-avatar.jpg'" />
    </template>
    <template #frozen="{ row }">
      <el-tag :type="row.frozen ? 'danger' : 'success'">
        {{ row.frozen ? '已冻结' : '正常' }}
      </el-tag>
    </template>
    <template #status="{ row }">
      <el-tag :type="row.status ? 'success' : 'danger'">
        {{ row.status ? '在线' : '离线' }}
      </el-tag>
    </template>
    <template #level="{ row }">
      <el-tag :type="row.level === 1 ? 'primary' : 'warning'">
        {{ row.level === 1 ? '普通' : '高级' }}
      </el-tag>
    </template>
  </generic-list>
</template>

<script>
import GenericList from '@/components/GenericList.vue';
import { getAdmins, createAdmin, updateAdmin, deleteAdmin } from '@/api/admin';

export default {
  components: {
    GenericList
  },
  data() {
    return {
      mediaUrl: process.env.VUE_APP_MEDIA_URL,
      queryFields: [
        { prop: 'username', label: '账号', type: 'input' },
        { prop: 'status', label: '状态', type: 'select', options: [
          { label: '在线', value: true },
          { label: '离线', value: false }
        ]}
      ],
      columns: [
        { prop: 'id', label: 'ID' },
        { prop: 'username', label: '账号' },
        { prop: 'avatar', label: '头像', slot: 'avatar' },
        { prop: 'permission', label: '权限等级' },
        { prop: 'balance', label: '余额' },
        { prop: 'frozen', label: '冻结状态', slot: 'frozen' },
        { prop: 'level', label: '等级', slot: 'level' },
        { prop: 'status', label: '登录状态', slot: 'status' }
      ],
      formFields: [
        { prop: 'id', label: 'ID', type: 'input', disabled: true },
        { prop: 'username', label: '账号', type: 'input', disabled: true },
        { prop: 'password', label: '密码', type: 'input' },
        { 
    prop: 'avatar', 
    label: '头像', 
    type: 'image-upload', 
    action: process.env.VUE_APP_API_BASE_URL + '/upload', 
    headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') },
    limit: 1,
    accept: 'image/*'
  },
        { prop: 'permission', label: '权限等级', type: 'select', options: [
          { label: '普通管理员', value: 1 },
          { label: '高级管理员', value: 2 }
        ]},
        { prop: 'balance', label: '余额', type: 'input', inputType: 'number' },
        { prop: 'frozen', label: '冻结状态', type: 'switch' },
        { prop: 'level', label: '等级', type: 'select', options: [
          { label: '普通', value: 1 },
          { label: '高级', value: 2 }
        ]},
        { prop: 'status', label: '登录状态', type: 'tag', options: [
          { label: '在线', value: true, type: 'success' },
          { label: '离线', value: false, type: 'danger' }
        ]}
      ],
      editableFields: [
        'username',
        'password',
        'permission',
        'avatar'
      ],
      addFields: [
  'username',
  'password'
]
    };
  },
  methods: {
    async fetchData(queryParams) {
      try {
        const response = await getAdmins(queryParams);
        return {
          data: {
            list: response.data.rows,
            total: response.data.count
          }
        };
      } catch (error) {
        console.error('API Error:', error);
        throw error;
      }
    },
    addData(data) {
      return createAdmin(data);
    },
    updateData(data) {
      if (!data.id) {
        this.$message.error('ID 不能为空');
        return Promise.reject(new Error('ID 不能为空'));
      }
      const editableData = {};
      this.editableFields.forEach(field => {
        if (data[field] !== undefined && data[field] !== null) {
          editableData[field] = data[field];
        }
      });
      console.log(editableData);
      return updateAdmin(data.id, editableData);
    },
    deleteData(id) {
      return deleteAdmin(id);
    }
  }
};
</script>

<style scoped>
/* 添加自定义样式 */
</style>